<template>
  <div>
    <div class="card">
      <div class="card-header d-flex justify-content-between align-items-center">
        <span>Detalhes do Relatório de TimeSheet</span>
        <div>
          <b-button class="mr-2" variant="warning" size="sm" @click="openInstallments()">
            <i class="fa fa-dollar"></i>&nbsp;Gerar parcelas
          </b-button>
          <b-button variant="primary" size="sm" @click="print()">
            <i class="fa fa-print"></i>&nbsp;Imprimir
          </b-button>
        </div>
      </div>
      <div class="card-body">
        <div id="printme" class="col-sm-12">
          <div class="row">
            <div class="col-sm-12">
              <!-- <img src="/assets/img/logo.jpg" alt="" width="200px"> -->
              <h4 class="text-center border" style="background-color: #f3f3f2; padding: 10px 0;margin-bottom:0;border-bottom:0!important">
                <div class="d-flex">
                  <span style="flex: 1;">Relatório de TimeSheet</span>
                  <span style="padding-right: 10px;">{{ report.code }}</span>
                </div>
              </h4>
              <table class="table border lead" style="padding: 10px 0">
                <tbody v-if="report.customer">
                  <tr>
                    <th style="width:75px">Cliente:</th>
                    <td>{{ report.customer.social_name }}</td>
                  </tr>
                  <tr v-if="report.customer.cnpj">
                    <th style="width:75px">CNPJ:</th>
                    <td><span v-if="report.customer.cnpj">{{ report.customer.cnpj | VMask('##.###.###/####-##') }}</span></td>
                  </tr>
                  <tr v-if="report.customer.cpf">
                    <th style="width:75px">CPF:</th>
                    <td><span v-if="report.customer.cpf">{{ report.customer.cpf | VMask('###.###.###-##') }}</span></td>
                  </tr>
                  <tr>
                    <th style="width:75px">Contrato:</th>
                    <td>{{ report.contract.title }}</td>
                  </tr>
                  <tr>
                    <th style="width:75px">Período:</th>
                    <td><span v-if="report.month_is_equal">({{ report.get_month_ref }}) - </span>{{ report.start_tr_date | formatDate }} a {{ report.end_tr_date | formatDate }}</td>
                  </tr>
                </tbody>
              </table>
              <table class="table table-responsive-sm table-bordered table-striped lead">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Data</th>
                    <th>Profissional</th>
                    <th>Descrição</th>
                    <th class="text-right">Tempo</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(timesheet, itemIdx) in report.timesheets" :key="timesheet.pk">
                    <td>{{ itemIdx + 1 }}</td>
                    <td>{{ timesheet.timesheet_date | formatDate }}</td>
                    <td>{{ timesheet.employee.full_name }}</td>
                    <td>{{ timesheet.description }}</td>
                    <td><span class="pull-right">{{ timesheet.timesheet_hours }}</span></td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <th class="text-right" colspan="4">Horas Total</th>
                    <th><span class="pull-right">{{ report.total_hours }}</span></th>
                  </tr>
                  <tr v-if="report.contract">
                    <th class="text-right text-muted" colspan="4"><small>(Impresso somente se for contrato por hora)</small> Valor do contrato</th>
                    <th>{{ icon }} <span class="pull-right text-muted">{{ report.contract.value | formatPrice }}</span></th>
                  </tr>
                  <tr v-if="report.contract">
                    <th class="text-right" colspan="4">Valor Total</th>
                    <th style="width:150px">{{ icon }} <span class="pull-right">{{ report.total_price }}</span></th>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
          <div class="text-center lead" style="padding-top:20px;line-height:1em">
            <p>Rua Joaquim Floriano, 72, conj. 175 - Itaim Bibi - São Paulo - SP - Brasil F: 11 2528-1044</p>
            <p>www.pgsa.com.br</p>
          </div>
          <div class="page-break">
            <ul class="list-group">
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import GenericForm from '../../components/GenericForm';
import axios from 'axios';

export default {
  components: {
    GenericForm,
  },
  data() {
    return {
      isVisible: false,
      report: {},
      currency_moneys: [
        { value: 'r', text: 'Real', icon: 'R$' },
        { value: 'd', text: 'Dólar', icon: '$' },
        { value: 'e', text: 'Euro', icon: '€' },
      ],
    };
  },
  mounted() {
    axios.get('/timesheet/reports/' + this.$route.params.pk)
      .then(res => {
        this.report = res.data.data;
      });
  },
  computed: {
    // totalHours() {
    //   return this.report.timesheets && this.report.timesheets.map(t => {
    //     const [hour, minutes] = t.timesheet_hours.split(':');

    //     return {
    //       hour,
    //       minutes,
    //     }
    //   }).reduce(function(memo, t) {
    //     memo[0] += parseInt(t.hour, 10)
    //     memo[1] += parseInt(t.minutes, 10)
    //     if (memo[1] >= 60) {
    //       memo[0] += ~~(memo[1] / 60)
    //       memo[1] = memo[1] % 60
    //     }
    //     return memo
    //   }, [0, 0]).map(function(t) {
    //     if (t < 10) {
    //       return '0' + t
    //     }
    //     return t
    //   }).join(':');
    // },
    // totalMinutes() {
    //   if (!this.totalHours) {
    //     return 1;
    //   }

    //   return this.getMinutes(this.totalHours);
    // },
    icon() {
      if (!this.report.contract) {
        return null;
      }

      const currency = this.currency_moneys.find(c => c.value == this.report.contract.currency_money);

      if (!currency) {
        return null;
      }

      return currency.icon;
    },
  },
  methods: {
    // getMinutes(hms) {
    //   var a = hms.split(':');

    //   var minutes = (+a[0]) * 60 + (+a[1]);

    //   if (minutes == 0) {
    //     return 1;
    //   }

    //   return minutes;
    // },
    print() {
      window.open('/app/timesheet/report/detail/' + this.$route.params.pk + '/print');
    },
    openInstallments() {
      this.$router.push({ path: '/contracts/' + this.report.contract.pk, query: { generate: true, total_price: this.report.total_price } });
    }
  }
}

</script>
